module.exports = __webpack_public_path__ + "img/ESBE_1570.bafd5a34.png";